import { SortMode } from "../../types/home";

// ============================================
// SORT CONTROL — Refined
// ============================================
// Tighter padding, softer border, smaller chevron.

export interface SortControlProps {
  sortMode: SortMode;
  onSortChange: (mode: SortMode) => void;
}

const SORT_OPTIONS: { value: SortMode; label: string }[] = [
  { value: "recent", label: "Recent" },
  { value: "oldest", label: "Oldest" },
  { value: "alpha", label: "A–Z" },
  { value: "insurer", label: "Insurer" },
];

export function SortControl({ sortMode, onSortChange }: SortControlProps) {
  return (
    <div className="relative">
      <select
        value={sortMode}
        onChange={(e) => onSortChange(e.target.value as SortMode)}
        className="appearance-none pl-2.5 pr-7 py-1.5 text-[11px] font-medium text-slate-500 bg-white border border-slate-200/60 rounded-lg hover:bg-slate-50 hover:text-slate-700 focus:outline-none focus:border-teal-300 focus:ring-1 focus:ring-teal-500/10 cursor-pointer transition-all"
      >
        {SORT_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <svg
        className="absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-slate-300 pointer-events-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    </div>
  );
}
